import { Store } from "redux";
import { connect } from "react-redux";
import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";
import { ICh_StateTree } from "../../reducers/interfaces";
import getChoir from "../../reducers/choir/actions/getChoir";
import { ICh_ChoirState } from "../../reducers/choir/models";
import { getPhotoURL } from "../dashboard/Meta/Additional/PhotoGaleryEditor/utils";

export default {
    component: loadableComponent,
    loadData: ({ dispatch }: Store<ICh_StateTree, any>, path: string) => dispatch(getChoir(path)),
    renderSeo: ({ getState }: Store<ICh_StateTree>, allMessage: any, lang: string) => {
        const choir = getState().choir as ICh_ChoirState;
        const description = choir !== 'error' ? choir.meta.general.description : '';
        const title = choir === 'error' ? 'Hiba történt' : choir.name;
        const photoId = choir !== 'error' && choir.meta.additional?.photos?.[0];
        let image = undefined;
        if (photoId) {
            image = getPhotoURL(photoId);
        }
        SeoRenderer({
            title,
            description,
            ogDescription: description,
            ogTitle: title,
            app: 'choir',
            allMessage,
            lang,
            image,
        });
    },
};
